import { QuestionCircleOutlined } from "@ant-design/icons";
import { Button, Tabs, Tooltip } from "antd";
import { Content } from "antd/lib/layout/layout";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import GetUnitPerformanceApi from "../../api/units/GetUnitPerformanceApi";
import DashboardBreadcrumb from "../../components/layout/DashboardBreadcrumb";
import SwitchUnitPlansModal from "../../components/modal/SwitchUnitPlansModal";
import UnitTree from "../../components/tree/UnitTree";
import UnitObjectives from "../../components/unit-plans/UnitObjectives";
import UnitOverview from "../../components/unit-plans/UnitOverview";
import { getPluralString } from "../../helpers/wordHelpers";

const { TabPane } = Tabs;

function Unit() {
  const [canStart, setCanStart] = useState(false);
  const [canShow, setCanShow] = useState(false);
  const [unitDetails, setUnitDetails] = useState();
  const [switchModal, setSwitchModal] = useState(false);
  const perfCycleState = useSelector((state) => state.perfCycleState.value);
  const topPlanState = useSelector((state) => state.topPlanState.value);
  const proHeight = document.body.clientHeight;
  let curLocation = useLocation();

  useEffect(() => {
    getUnitData();
  }, [curLocation, perfCycleState]);

  async function getUnitData() {
    let path = curLocation.pathname;
    let id = path.split("/units/");
    const apiResponse = await GetUnitPerformanceApi(id[1], perfCycleState.id);

    if (apiResponse.message === "success") {
      setUnitDetails(apiResponse);
      setCanShow(true);
    }
    setCanStart(true);
  }

  const left = (
    <>
      <div className="flex items-baseline">
        <Link to="/units">
          <div className="text-sm pri-font text-gray-400 hover:text-gray-500">
            Units
          </div>
        </Link>
        <div className="mx-1 text-lg">/</div>
        <div className="text-lg pri-font max-w-xs truncate">
          {unitDetails?.unit?.name || "..."}
        </div>
      </div>
    </>
  );

  return (
    <>
      <Content style={{ backgroundColor: "#fff" }}>
        <DashboardBreadcrumb left={left} />
        <div
          style={{
            height: proHeight - 122,
            overflow: "auto",
          }}
          className="custom-scroll"
        >
          <Tabs defaultActiveKey="1" centered>
            <TabPane
              tab={<div className="w-32 text-center">Overview</div>}
              key="1"
            >
              <div className="px-6">
                <UnitOverview data={unitDetails} />
              </div>
            </TabPane>
            <TabPane
              tab={
                <div className="w-32 text-center">
                  {getPluralString(topPlanState) || "Top plans"}
                </div>
              }
              key="2"
            >
              <div className="px-6">
                <UnitObjectives />
              </div>
            </TabPane>
            <TabPane
              tab={<div className="w-32 text-center">Hierarchy</div>}
              key="3"
            >
              <div className="px-6">
                <UnitTree />
              </div>
            </TabPane>
          </Tabs>
        </div>
      </Content>
      <SwitchUnitPlansModal
        visible={switchModal}
        handleCancel={() => setSwitchModal(false)}
      />
    </>
  );
}

export default Unit;
